__webpack_require__.p = "/assets/demos/web-app-attendance/v1/";